import React from 'react';
import PropTypes from 'prop-types';
import { zoneIsSelected } from 'util/zoneDrawing';

// components
import ZoneCollectionLayer from './ZoneCollectionLayer';

// utils
import { styleMethods } from 'dataviz/config/map';

/** A map layer for displaying script generated as a scenario. */
const ScenarioLayer = ({
  selectedZoneIds,
  map,
  productValidationValues,
  scenario
}) => (
  <section className='vra-scenario-layer'>
    <ZoneCollectionLayer
      layerName='scenario'
      map={map}
      styleFunction={
        styleMethods.seedRate.bind(null, scenario, productValidationValues)
      }
      zoneIsSelected={zoneIsSelected.bind(null, selectedZoneIds)}
      zones={scenario.zones}
    />
  </section>
);

ScenarioLayer.propTypes = {
  map: PropTypes.object, // Inserted by mapping/leaflet.
  productValidationValues: PropTypes.object.isRequired,
  scenario: PropTypes.object.isRequired,
  selectedZoneIds: PropTypes.arrayOf(PropTypes.string).isRequired
};

export default ScenarioLayer;
